import WrapperBox from 'components/WrapperBox';
import {
  ChaseCardCoin,
  ChaseCardContainer,
  ChaseCardContent,
  ChaseCardContentInfo,
  ChaseCardContentTitle,
  ChaseCardImage,
  ChaseCardImageAvatar,
  ChaseCardImageCoin,
  ChaseCardImages,
} from './ChaseCard.styles';
import { ChaseCardProps } from './ChaseCard.types';
import Title from 'components/Typography/Title';
import Label from 'components/Typography/Label';
import Button from 'components/Button';
import coin from 'assets/icons/coins/coin.png';
import Paragraph from 'components/Typography/Paragraph';
import usePersonalAssistant from 'store/usePesonalAssistant';
import { useTranslation } from 'react-i18next';
import { handleCoins } from 'helpers/MissionsHelper';

const ChaseCard = ({
  width = '100%',
  height = '13.188rem',
  borderRadius = '0.875rem',
  shadowColor = '#007AD1',
  coins,
  title,
  distance,
  mode,
  onStart,
  avatarName,
  imageSrc,
  ...rest
}: ChaseCardProps): JSX.Element => {
  const { pa } = usePersonalAssistant();
  const { t } = useTranslation();
  return (
    <WrapperBox
      width={width}
      height={height}
      shadowColor={shadowColor}
      {...rest}
    >
      <ChaseCardContainer>
        <ChaseCardImages data-testid="images">
          <ChaseCardImage src={imageSrc} />
          <ChaseCardImageAvatar src={pa?.avatar} />
        </ChaseCardImages>
        <ChaseCardContent>
          <ChaseCardCoin>
            <Paragraph>{handleCoins(+coins)}</Paragraph>
            <ChaseCardImageCoin src={coin} />
          </ChaseCardCoin>
          <ChaseCardContentTitle>
            <Title color="#161F21" level={3} renderAs="h3">
              {title}
            </Title>
            <ChaseCardContentInfo>
              <Label>{distance}</Label>
              <Label>.</Label>
              <Label>{mode}</Label>
            </ChaseCardContentInfo>
          </ChaseCardContentTitle>
          <Button
            rotation="-3.21deg"
            shadowColor="black"
            width="9.188rem"
            onClick={onStart}
          >
            {t('chase.start')}
          </Button>
        </ChaseCardContent>
      </ChaseCardContainer>
    </WrapperBox>
  );
};

export default ChaseCard;
